import { mantle } from '@0xtorch/core'
import { mantle as viemMantle } from 'viem/chains'
import { type Client, createClient } from '../../client'
import { type Explorer, createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createMantleChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createMantleChainCustom({
    client: createClient({
      chain: viemMantle,
      httpRpcs: mantleHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'Mantlescan',
      baseUrl: 'https://mantlescan.xyz',
      chainId: 5000,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateMantleChainParameters = {
  client: Client
  explorer: Explorer
}

export const createMantleChainCustom = ({
  client,
  explorer,
}: CreateMantleChainParameters): Chain => ({
  id: 5000,
  network: 'mantle',
  name: 'Mantle',
  nativeToken: {
    name: 'Mantle',
    symbol: 'MNT',
    decimals: 18,
    currency: mantle,
  },
  wrappedTokenAddresses: new Set([
    '0x78c1b0c915c4faa5fffa6cabf0219da63d7f4cb8',
  ]),
  explorer,
  client,
  blockTime: undefined,
  coingeckoId: 'mantle',
  defillamaId: 'mantle',
})

export const mantleHttpRpcs: HttpRpc[] = [
  // Endpoint is not working
  // {
  //   url: 'https://rpc.ankr.com/mantle',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 3000n,
  // },
  {
    url: 'https://rpc.mantle.xyz/',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://mantle.publicnode.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 20_000n,
  },
  {
    url: 'https://1rpc.io/mantle',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  {
    url: 'https://mantle-rpc.publicnode.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://mantle.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const mantleWebsocketRpcUrls: readonly string[] = [
  'wss://wss.mantle.xyz',
  'wss://mantle.publicnode.com',
]
